/**
 * 通过upcode搜索用户
 * @author zhenn
 * @time 2016-11-16
 */
import React, {Component} from 'react';
import {findDOMNode} from 'react-dom';
import upcodepb from './upcodepb';
import Pbajax from 'up-pbajax';
import publicpb from '../global/publicpb';
import Notification from '../global/notification';
import loading from 'c-loading';
import env from 'c-nenv';
import url from 'c-url';
import cache from '../global/cache';
import lang from '../lang/index';

class Upcode extends Component {

    static defaultProps = {
        searchSuccess: ()=>{}
    };

    constructor(props) {
        super(props);
        this.state = {
            value: ''
        };
    }

    componentWillMount() {
        this.pbajax = new Pbajax();
        let upcode = url.query('upcode');
        if (upcode) {
            loading.show({
                text: 'loading'
            });
            this.submit(upcode);
        }
    }

    componentDidMount() {
        let el = findDOMNode(this.refs.upcode);
        el && el.focus();
    }

    confirm = () => {
        // 提交绑定操作
        let self = this;
        let code = $(findDOMNode(self.refs.upcode)).val().trim();

        if (code.length == 0) {
            new Notification({
                content: '<b>' + lang.template('请输入Up号') + '</b>'
            }).create();
            return;
        }

        loading.show({
            text: 'loading'
        });
        self.submit(code);
    }

    submit(upliveCode) {

        let self = this;
        let data = new upcodepb.Search.UserCode.Request({
            upliveCode
        });

        this.pbajax.do(
            {
                service: 'service',    
                api: '/search/user/code',  
                header: {},
                inchina: url.query('apiregion') != 'sg'
            }, 

            data, 

            (res) => {
            
                let $tip = lang.template('系统错误');
                let dataWrap, data;

                loading.hide();

                try {
                    dataWrap = publicpb.Result.decode(res);
                } catch(e) {
                    if (e.message.indexOf('Illegal group end indicator for Message') >= 0) {
                        $tip = lang.template('数据请求失败');
                    }
                }
                
                if (dataWrap.code == 1) {
                    if (dataWrap.data) {
                        data = upcodepb.Search.UserCode.Response.decode(dataWrap.data.value);
                        this.props.searchSuccess(data.userInfo);
                        cache.setCache('userInfo', data.userInfo);
                        return;   
                    } else {
                        $tip = lang.template('输入的Up号不存在');
                    }
                } else {
                    if (dataWrap.code == 4116) {
                        $tip = lang.template('输入的Up号不存在');
                    }
                }
                new Notification({
                    content: $tip
                }).create();

            },

            () => {
                loading.hide();
                new Notification({
                    content: lang.template('网络连接有误, 请稍后再试')
                }).create();
            }
        );
    }

    onChange(e) {
        this.setState({
            value: e.target.value
        });
    }
    
    componentWillUnmount(){
        this.pbajax.cancel();
    }
    render() {
        let upcode = url.query('upcode');
        let langType = lang.getLangType();
        if (upcode) {
            return <div></div>;
        }
        return (
            <div className="inputcode">
                <div className="code">
                    <input type="text" ref="upcode" onChange={this.onChange.bind(this)} placeholder={lang.template('请输入Up号')} value={this.state.value} />
                    <button className="confirm" type="button" onClick={this.confirm}>{lang.template('确认')}</button>
                </div>
                <div className="tip">
                    <h3>{lang.template('第一步：打开Up直播点击个人主页')}</h3>
                    <div className="pic1"></div>
                    <h3>{lang.template('第二步：查看Up号并输入')}</h3>
                    <div className="pic2"></div>
                </div>
            </div>
        );
    }
}

export default Upcode;






// WEBPACK FOOTER //
// ./js/search/upcode.js